import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadingProfile: -1,
    loadingFee: -1,
    updatingFee: -1,
    updatingPqFee: -1,
    updateAvailableChat: -1,
    updatePriorityQueue: -1,
    getCurrencies: -1,
    getFees: -1,
    updateCurrency: -1,
    setPriorityQueue: -1,
    workingTimes: -1,
    setWorkingTimes: -1,
  },
  data: null,
  updatedProfile: {},
  workingTimes: [],
  currencies: [],
  fee: {
    initialMessage: '0',
    subMessage: '0',
    consultSummary: '0',
    currency: {
      currencyName: 'Singapore',
      currencyCode: 'SGD',
    },
  },
  fees: [],
  error: null,
  errors: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.DOCTOR_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingProfile: 0,
        },
        error: null,
      };
    case ACTION_TYPES.DOCTOR_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingProfile: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.DOCTOR_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingProfile: 2,
        },
        error: error?.data,
      };

    case ACTION_TYPES.DOCTOR_FEE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingFee: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_FEE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingFee: 1,
        },
        fee: payload.data,
      };
    case ACTION_TYPES.DOCTOR_FEE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingFee: 2,
        },
        error: {
          message: 'Cannot update fee successfully',
        },
      };

    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingPqFee: 0,
        },
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingPqFee: 1,
        },
        fee: payload.data,
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_FEE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updatingPqFee: 2,
        },
        error: {
          message: 'Cannot update priority queue fee successfully',
        },
      };

    case ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAvailableChat: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAvailableChat: 1,
        },
        data: {
          ...state.data,
          ...payload.data,
        },
      };
    case ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateAvailableChat: 2,
        },
        error,
      };

    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updatePriorityQueue: 0,
        },
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updatePriorityQueue: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_PRIORITY_QUEUE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updatePriorityQueue: 2,
        },
        error,
      };

    case ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          getCurrencies: 0,
        },
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          getCurrencies: 1,
        },
        currencies: payload.data,
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          getCurrencies: 2,
        },
        error,
      };

    case ACTION_TYPES.DOCTOR_FEE_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          getFees: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_FEE_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          getFees: 1,
        },
        fees: payload.data,
      };
    case ACTION_TYPES.DOCTOR_FEE_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          getFees: 2,
        },
        error,
      };
    case ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateCurrency: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updateCurrency: 1,
        },
      };
    case ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateCurrency: 2,
        },
        error,
      };

    case ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          setPriorityQueue: 0,
        },
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          setPriorityQueue: 1,
        },
      };
    case ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          setPriorityQueue: 2,
        },
        error: {
          setPriorityQueue: error.data,
        },
      };

    case ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          workingTimes: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_SUCCEED:
      return {
        ...state,
        workingTimes: payload.data,
        status: {
          ...state.status,
          workingTimes: 1,
        },
      };
    case ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          workingTimes: 2,
        },
        error: {
          workingTimes: error.data,
        },
      };

    case ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_REQUESTED:
      return {
        ...state,
        errors: {
          setWorkingTimes: undefined,
        },
        status: {
          ...state.status,
          setWorkingTimes: 0,
        },
      };

    case ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_SUCCEED:
      return {
        ...state,
        workingTimes: payload.data,
        status: {
          ...state.status,
          setWorkingTimes: 1,
        },
      };
    case ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          setWorkingTimes: 2,
        },
        errors: {
          setWorkingTimes: error.data,
        },
      };
    default:
      return state;
  }
}
